import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionState {
  $planUsage = new BehaviorSubject<any>({});
  planUsage = this.$planUsage.asObservable();

  public get planUsageValue(): any {
    return this.$planUsage.value;
  }

  public set planUsageValue(planUsages: any) {
    this.$planUsage.next(planUsages);
  }

  $planUpgrade = new BehaviorSubject<Object>(null);
  planUpgrade = this.$planUpgrade.asObservable();

  public get planUpgradeMessage(): Object {
    return this.$planUpgrade.value;
  }

  public set planUpgradeMessage(planUpgrade: Object) {
    this.$planUpgrade.next(planUpgrade);
  }

  $closeSideNavigation = new BehaviorSubject<boolean>(false);
  closeSideNavigation = this.$closeSideNavigation.asObservable();

  public get closeSideNav(): boolean {
    return this.$closeSideNavigation.value;
  }

  public set closeSideNav(closeSide: boolean) {
    this.$closeSideNavigation.next(closeSide);
  }
}
